<template>
  <!-- TODO: 参考https://h5.lanhushipin.cn/html/zhuxiao.html调整内容 -->
  <div class="logoff-agreement">
    <h1>《“搜机网”账号注销须知》</h1>
    <p>[重要] 在您注销您的“搜机网”账号之前，请充分阅读、理解并同意下列事项：</p>
    <p>【特别提示】注销“搜机网”账号为不可恢复的操作，注销账号后您将无法再使用本“搜机网”账号或找回您发布、关注、添加、绑定的任何内容或信息（即使您使用相同的手机号码再次注册并使用“搜机网”）。</p>
    <p>“搜机网”账号指您依据“搜机网”的用户协议创建，供您登录并以注册用户身份使用“搜机网”软件及相关服务的凭证。</p>
    <p>请确保您所申请注销的“搜机网”账号应当是您本人依照《“搜机网”用户协议》的约定创建并由本公司提供给您本人的账号。您应当依照本公司规定的程序或网站上的提示注销“搜机网”账号。</p>
    <p>
      建议您在注销前自行备份“搜机网”账号相关的所有信息，并请确认与本“搜机网”账号相关的所有服务均已进行妥善处理。注销完成后，“搜机网”将删除您的个人信息或对其进行匿名化处理（法律法规另有规定的除外）。请您知悉并理解，根据相关法律法规规定，相关日志记录“搜机网”将保留不少于6个月的时间。
    </p>
    <p>1.我们对您注销“搜机网”账号的决定深表遗憾。如果您仍决定继续进行账号注销，您的账号需同时满足以下条件：</p>
    <p>1.1 账号处于正常使用中且近30天内无任何账号被限制的记录，无被盗、违规、封禁风险。</p>
    <p>1.2 账号下所有关联业务的资产（包括收益等）及权益（包括会员身份、团队素材等）均已结清或自愿放弃；</p>
    <p>1.3 账号无任何纠纷，包括投诉举报或被投诉举报，所有服务均已完成或已自愿放弃。</p>
    <p>2.“搜机网”账号注销后，您将无法在“搜机网”软件其他第三方服务中登录、使用本“搜机网”账号，也将无法找回本“搜机网”账号中及与账号相关的任何内容或信息，包括但不限于：</p>
    <p>2.1. 个人已提交的身份信息、账号信息、“搜机网”好友关系等信息。</p>
    <p>2.2. 已发布和解锁购买的素材作品、转发、粉丝、加入团队、收藏等内容数据。</p>
    <p>2.3 账号内钱包账户余额、奖励、收益、交易记录等信息将被作废及删除。</p>
    <p>2.4 通过本“搜机网”账号使用、授权登录或绑定本“搜机网”账号后使用的“搜机网”相关服务或第三方服务的相关记录将无法找回。您将无法再登录、使用上述服务，通过上述服务曾获得的资产或虚拟权益等财产性利益视为您同意放弃，将无法继续使用。
      您理解并同意，“搜机网”无法协助您重新恢复上述服务。</p>
    <p>2.5
      请确认账号内无任何资产或虚拟权益，您在注销程序完成之前获得的资产、虚拟权益等财产性利益视为您同意放弃，将无法继续提现、使用或处分。您理解并同意，您将放弃账号的所有资产或权益（包括已产生但未消耗完毕的或未来预期的收益），“搜机网”无法协助您恢复上述服务，也无法找回账号相关的任何内容或信息。
    </p>
    <p>3.“搜机网”账号注销将导致本公司终止为您提供服务，依“搜机网”用户协议 《“搜机网”用户服务协议》和《“搜机网”隐私政策》等约定的双方权利义务终止，依法律法规另有规定、本页面其他条款另行约定不得终止的或依其性质不能终止的除外。
    </p>
    <p>4.在您的“搜机网”账号注销期间，如果您的账号被封禁或涉及争议纠纷，包括但不限于：投诉、举报、诉讼、仲裁、国家有权机关调查等，您理解并同意，“搜机网”有权自行决定是否终止本账号的注销而无需另行得到您的同意。</p>
    <p>5.注销本“搜机网”账号并不代表本“搜机网”账号注销前的账号行为和相关责任得到豁免或减轻。</p>
    <p>6.具体的注销处理时间和信息释放时间，以确认注销页面中显示的为准。</p>
  </div>
</template>

<script>
export default {
  name: 'LogoffAgreement'
}
</script>

<style scoped lang="scss">
.logoff-agreement {
  width: 98%;
  margin: 0 auto;
  padding: 1%;
  font-size: 14px !important; // 防止被浏览器默认样式影响
  line-height: 1.6;
  text-indent: 32px;

  h1 {
    text-align: center;
    margin-bottom: 20px;
    text-indent: 0;
    margin-top: 10px;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 10px;
  }
}
</style>
